import { Button } from "@/components/ui/buttons/button";

interface RaidsCardProps {
  currentRaidId: string | null;
  handleReconnectToRaid: () => void;
  handleStartRaid: () => void;
  isInitializingDuel: boolean;
}

export const RaidsCard = ({
  currentRaidId,
  handleReconnectToRaid,
  handleStartRaid,
  isInitializingDuel,
}: RaidsCardProps) => {
  const isDisabled = isInitializingDuel || true; // Disabled RAIDS on ALPHA for now
  return (
    <Button
      onClick={currentRaidId ? handleReconnectToRaid : handleStartRaid}
      disabled={isDisabled}
      variant={isDisabled ? "gray" : currentRaidId ? "red" : "default"}
      className="w-full"
    >
      <div
        className={`rounded-xl p-[4px] shadow-xl w-full ${
          isDisabled ? "" : "group"
        } relative transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed animate-slide-left-fade opacity-0`}
        style={{ animationDelay: "250ms" }}
      >
        <div
          className={`relative h-14 xs:h-24 px-4 xs:px-8 gap-4 xs:gap-8 overflow-hidden flex items-center justify-between ${
            currentRaidId ? "animate-pulse" : ""
          } ${isDisabled ? "" : ""}`}
        >
          {/* Background Graphic */}
          <div
            className={`top-0 right-0 bottom-0 absolute ${
              isDisabled
                ? ""
                : "bg-gradient-to-l from-pk-blue-4/10 to-transparent"
            } w-1/2 skew-x-[-20deg] translate-x-4`}
          />

          {/* Animated Shine */}
          <div
            className={`absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full ${
              isDisabled ? "" : "group-hover:translate-x-full"
            } transition-transform duration-700 ease-in-out ${
              currentRaidId ? "animate-pulse" : ""
            }`}
          />

          <div className="z-10 relative flex flex-col items-start gap-1">
            <span className="drop-shadow-[3px_3px_0_rgba(0,0,0,0.8)] font-black text-white text-lg xs:text-3xl italic tracking-wider">
              {currentRaidId ? "RECONNECT" : "RAIDS"}
            </span>
            <div className="flex items-center gap-2">
              <span
                className={`px-2 py-0.5 rounded-sm font-bold text-[10px] uppercase tracking-wider ${
                  isDisabled
                    ? "bg-[#5D4037]/80 text-white"
                    : "bg-pk-blue-4 text-white"
                }`}
              >
                CO-OP
              </span>

              <span
                className={`font-bold text-xs xs:text-sm uppercase tracking-widest ${
                  isDisabled ? "text-pk-gray-4" : "text-pk-gray-4"
                }`}
              >
                {isDisabled
                  ? "Coming Soon"
                  : currentRaidId
                  ? "Raid Active"
                  : "Team Battles"}
              </span>
            </div>
          </div>

          <span className="drop-shadow-lg text-2xl xs:text-5xl filter transform">
            {currentRaidId ? "🔌" : "🏝️"}
          </span>
        </div>
      </div>
    </Button>
  );
};
